module.exports = __webpack_public_path__ + "static/img/grip-vertical.9dc50b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/grip-vertical.svg
// module id = IpeL
// module chunks = 6